// extracted by mini-css-extract-plugin
export default {"root":"MobileActionBar_root__6FuWL","spacer":"MobileActionBar_spacer__HuKO3","primary":"MobileActionBar_primary__501Z3","secondary":"MobileActionBar_secondary__naHyz"};